import {
  SuggestionDocument,
  SuggestionResult,
  Suggestions
} from 'types/Suggestions';

export const extractSuggestionValues = (suggestions: Suggestions) => {
  const suggestionsValues: string[] = [];

  if (suggestions?.results) {
    const suggestionResultsList: SuggestionResult[] = Object.values(
      suggestions?.results
    );
    suggestionResultsList.forEach((suggestion: SuggestionResult) => {
      const document: SuggestionDocument = suggestion?.document;
      if (document?.value) {
        suggestionsValues.push(document.value);
      }
    });
  }

  return suggestionsValues;
};
